export default __webpack_public_path__ + "static/media/Twitter.67d7b8ca.svg";